export function sendOutgrowEvent(event: OutgrowEvent) {
  window.parent.postMessage(event, { targetOrigin: "*" });
}

export type OutgrowEvent =
  | { type: "navigate"; payload: { route: string } }
  | { type: "publishBot" }
  | { type: "changeBotName"; payload: { name: string } }
  | { type: "syncUpdatedAt" }
  | { type: "logout"; payload: { route: string } }
  | { type: "openBilling"; payload: { route: string } }
  | { type: "openTeam"; payload: { route: string } };
